import React from 'react';
import './MenuWeek.css'; 
import {AddRecipeInMenu} from '../../molecules'
import { ModalContainer } from '../../atoms'; 
import {useSelector, useDispatch} from 'react-redux' 
import { getPlan, postPlan, updatePlan, deletePlan, getRecipe} from '../../../store/api' 
import { Calendars, ProductList, menuCreate, Settings, PlanSlides } from '../' 
import { checklist, getRandomElement, filtrSearchMenu } from "../../../utils/utils"; 

export function MenuDays(props) {
  const {plans, statusPlan} = useSelector(state => state.plans) // Сохраненные планы с сервера
  const dispatch = useDispatch();
  const { currentUser, statusUser } = useSelector(state => state.currentUser) // данные пользователя
  const servings = currentUser.settings.sumFamily // к-во порций
  const today = new Date();
  const {ingredients} = useSelector(state => state.ingredients) // Список ингредиентов из базы
  const {recipes, sts} = useSelector(state => state.recipes) // Список рецептов из базы
  const [blockedSaveMenu, setBlockedSaveMenu] = React.useState(false) //Просроченная дата или нет 
  const submitDisabled = sts === null || sts === 'loading' || blockedSaveMenu
  const [choiceDate, setChoiceDate] = React.useState([]) //Массив выбранных дат в календаре
  const [randomUniq, setRandomUniq] = React.useState([])  
  const [clickCreate, setClickCreate] = React.useState(false) //Отслеживание клика для вывода прелоудера в меню
  const [visibility, setVisibility] = React.useState(false) 
  const [print, setPrint] = React.useState(false) 
  const [settingDisabled, setSettingDisabled] = React.useState(true) 
  const [saveMenuWeek, setSaveMenuWeek] = React.useState([])//Наличие в базе меню на выбранные даты
  const [changeMenuDay, setChangeMenuDay] = React.useState(false)
  let getLocalDate = JSON.parse(localStorage.getItem('datePoint')); 
  const [isOpen, setIsOpen] = React.useState(false); 
  const { cookingTime, kitchenware, stopProducts,typeOfDiet } = currentUser.settings
  let urlString = `cookingTime=${cookingTime}`
  let randIndex 
  const [positionMenuItem, setPositionMenuItem] = React.useState({});   
  //При изменении настроек, запрашивает новый список рецептов
  React.useEffect(()=> { 
    if(statusUser === 'resolved') {
      const param = parametr()
      dispatch(getRecipe({urlString, param}))
      setSettingDisabled(false)
    }
  },[currentUser])  
  // запрос список меню из базы при монтировании страницы
  React.useEffect(() => {
    dispatch(getPlan(currentUser._id))
  },[])
 
  // Остановка прелоудера при получении данных
  React.useEffect(()=> {
    if(statusPlan === 'resolved') {
      setClickCreate(false)
    }
  }, [statusPlan])

  //Поиск созданных меню на выбранные даты в Redux Toolkit при изменении плана или даты
  React.useMemo(() => {  
    let todayMenuWeek = plans.filter( i => choiceDate.some( k => i.date === k.date )); //ищем сгенерированные меню на выбранные даты
    if(todayMenuWeek === undefined || todayMenuWeek.length ===0) {
      setSaveMenuWeek([])
    } else if (todayMenuWeek.length > 0 ) {
      setSaveMenuWeek(todayMenuWeek.sort(function(a, b) {
        return a.date - b.date;
      })
      )
    } 
  },[choiceDate, plans])
  

                                       /* КАЛЕНДАРЬ*/
  //Обновляет выбранные даты в календаре, если даты старые блокирует изменения,если нет то записывает дату в стэйт
  function handleDateRange(data) {
    setChangeMenuDay(false)
    const blockedSaveMenu = data.some((i)=> {
      return i.date < today.setHours(0,0,0,0)
    })
    localStorage.setItem('datePoint', JSON.stringify(data));
    setBlockedSaveMenu(blockedSaveMenu)
    setChoiceDate(data)
  } 

  //Видимость календаря при клике
  function handleCalendarVisibility() {
    setVisibility(!visibility)     
  }

                   /* Формирование запроса рецептов подходящих user */

  // Создание параметров из настроек для запроса рецептов
  function parametr() {
    let param='' 
    kitchenware.map(i=> {
      if (i.boolean) {
        param = param + `&ware[]=${i.nameEn}`
      } 
    })
    stopProducts.map(i=> param = param + `&stopProducts[]=${i}`)
    typeOfDiet.map(i=> {
      if (i.boolean) {
        param = param + `&type[]=${i.nameEn}`
      } 
    })
    return param
  } 

  // Подбор массива рецептов для замены
  function randomElement(keyword) {
    const keywordSearch = keyword.toLowerCase();
    const NewArray = recipes.filter((item) => {
      return item.category.toLowerCase().includes(keywordSearch)
    })
    if(NewArray.length > 0) { 
      const idMenu = NewArray.map(item=> item._id)
      const random = generateUniqueRandom(idMenu) 
      return random
    } 
  }

  //Выбор рандомно рецепта из массива
  function generateUniqueRandom(arr) {
    randIndex = Math.floor(Math.random() * arr.length)
    if(!randomUniq.includes(randIndex)) { 
      setRandomUniq([...randomUniq, randIndex])
      return arr[randIndex] 
    } else { 
        if(randomUniq.length < arr.length) { 
          return generateUniqueRandom(arr);
        } else { 
          setRandomUniq([])
          return arr[randIndex]
        }
      }
  } 

  //Генерация и сохранение меню в Redux Toolkit
  function handleGeneration() { 
    setClickCreate(true)
    if(blockedSaveMenu) {
      props.blockedSaveMenu('blockedSaveMenu')
    } else {
      const exl = genNewMenu()
      let todayMenuBase = plans.filter( i => choiceDate.some( k => i.date === k.date )); //ищем сгенерированные меню на выбранные даты сохраненные в базе
      let todayNewMenu = exl.filter( i => todayMenuBase.every( k => k.date !== i.date )) //план на новые даты
      let todayUpdateMenu = exl.filter( i => todayMenuBase.some( k => k.date === i.date )) // план на старые даты
      if(todayMenuBase.length === 0) { 
        if(exl.length === 1) { 
          dispatch(postPlan(exl[0]))
        } else {
          exl.forEach((i)=> {
            dispatch(postPlan(i))
          }) 
        } 
      } else if (todayMenuBase.length !==0) {
        if(todayNewMenu.length >0) {
          if(todayNewMenu.length === 1) {
            dispatch(postPlan(todayNewMenu[0])) 
          } else {
            todayNewMenu.forEach((i)=> {
              dispatch(postPlan(i)) 
            })
          }
        }
        todayMenuBase.forEach((i)=> {
          const update = todayUpdateMenu.find(u=> u.date === i.date)
          dispatch(updatePlan({id: i._id, plan: update}))
        }) 
      }
    }
    handleChangeMenuDay()
  } 

//Формирование меню 
  function genNewMenu() {
    let NewArray 
    if(choiceDate.length > 0) {
      NewArray = menuCreate(currentUser, recipes, choiceDate, ingredients)
    } else {
      props.blockedSaveMenu('noDateSelected')
      NewArray = []
    } 
    return NewArray
  }
 
                              /* РУЧНАЯ КОРРЕКТИРОВКА МЕНЮ*/ 
  
  //Удаление из плана меню целого дня
  function handleDeleteMenuDay(id) {
    dispatch(deletePlan(id))
  }

  function handleChangeMenuDay() {
    setChangeMenuDay(true)
  }
  
  function handleChangeMenu() {
    setChangeMenuDay(false)
  }

  //функция замены рецепта в плане
  function handleReplace(id, recipe, powerMode, item) {
    const updatePlane = Object.assign({}, item, {[powerMode]: item[powerMode].map(k=> k === id ? recipe._id : k )}); 
    const newRecipe = changeMenus(updatePlane, recipes)
    dispatch(updatePlan({id: newRecipe._id, plan: newRecipe}))
    handleChangeMenuDay()
  }
 
    //функция замены плана на день
    function handleAutoReplaceMenu(item) {  
      const newPlane = menuCreate(currentUser, recipes, [item], ingredients) 
      dispatch(updatePlan({id: item._id, plan: newPlane[0]})) 
      handleChangeMenuDay() 
    }
   
    // Автоматическая замена блюда в плане
    function handleAutoReplace(recipe, mealsEn, mealsRu, item) { 
      const newDish = randomElement(recipe.category)
      if(newDish) {
        const updatePlane = Object.assign({}, item, {[mealsEn]: item[mealsEn].map(k=> k === recipe._id ? newDish : k )}); 
        const newRecipe = changeMenus(updatePlane, recipes)
        dispatch(updatePlan({id: updatePlane._id, plan: newRecipe}))  
        handleChangeMenuDay()
      } else {
        props.blockedSaveMenu('noSuitableDish')
      }
    }
  //функция добавления рецепта в план
  function handleAddDish(recipe, powerMode, item) {  
    const updatePlane = Object.assign({}, item, {[powerMode]: [...item[powerMode], recipe._id]}); 
    const newRecipe = changeMenus(updatePlane, recipes)
    dispatch(updatePlan({id: newRecipe._id, plan: newRecipe}))
    handleChangeMenuDay()
  }

  //функция добавления приема пищи в план
  function handleAddMeals(meals, item) { 
    let key 
    currentUser.settings.powerMode.map(i=> {
      if(i.nameEn === meals.mealsEn) {
        return key = i.dish[0].nameRu
      }
    })  
    const newDish = getRandomElement(filtrSearchMenu(recipes, key)) 
    if(newDish) { 
      const upPlane = Object.assign({}, item, {[meals.mealsEn]: [newDish]}); 
      const newRecipe = changeMenus(upPlane, recipes)
      dispatch(updatePlan({id: newRecipe._id, plan: newRecipe}))
       handleChangeMenuDay() 
    } else {
      props.blockedSaveMenu('noSuitableDish')
    }
  }

  //функция удаления рецепта из плана
  function handleDeleteRecipe(id, powerMode, item) {
    const updatePlane = Object.assign({}, item, {[powerMode]: item[powerMode].filter(k=> k !== id)}); 
    const newRecipe = changeMenus(updatePlane, recipes)
    dispatch(updatePlan({id: item._id, plan: newRecipe}))
    handleChangeMenuDay()
  } 

                                     /* Обработка данных для поиска в модальном окне*/ 
  // Передает данные в модалку для замены рецепта
  function handleEdite(id, mealsEn, mealsRu, item) {
    setIsOpen(true)
    setPositionMenuItem({
      id,
      powerMode: mealsEn,
      powerModeRu: mealsRu,
      item: item,
      replace: true
    })
  } 

  // Передает входные данные в модалку для добавления рецепта в план
  function handleAddMenuItem(mealsRu, mealsEn, item) {
    setIsOpen(true)
    setPositionMenuItem({
      powerMode: mealsEn,
      powerModeRu: mealsRu,
      day: item.date,
      item: item,
      replace: false
    })
  } 

  //При изменении меню, запускает перерасчет продуктов
  function changeMenus(recipe, recipes) {  
    const dex = {...recipe}
    dex.foodList = checklist(dex, recipes, ingredients)
    return dex
  }
 
  function handleCloseMenuItem() {
    setIsOpen(false) 
  } 

  function handlePrint() {
    setPrint(true)
  }
  
  return (
    <>
    <section className='menu-heading'>
    <h2 className='menu__title font35Bold'>Ваше меню</h2>
    <p className='menu__subtitle font24Bold'>Составьте меню на любое количество дней</p>
    <p className='menu__text font24Norm'>Вы можете менять/удалять/добавлять приемы пищи по желанию</p>
    <div className='menuweek__control'>
    <button 
        type='button'  
        disabled={settingDisabled ? true : ''} 
        className={`menuweek-button button__gener font20Norm color ${settingDisabled ? ('form__button_disabled') : ''}`} 
        onClick={props.handleSettings}
      > Настройки
      </button>
      <Calendars 
        userMenu={plans} 
        isOpen={visibility} 
        dateDay={getLocalDate}
        onDayRange={handleDateRange} 
        handleCalendarVisibility={handleCalendarVisibility}
      />
      <button 
        type='button' 
        disabled={submitDisabled ? true : ''} 
        className={`menuweek-button button__gener font20Norm color ${submitDisabled ? ('form__button_disabled') : ''}`} 
        onClick={handleGeneration}>{`${saveMenuWeek.length > 0 ? 'Обновить меню' : 'Создать меню'}`}
      </button>  
    </div>
    </section> 
      <ProductTable
        date={choiceDate} 
        statusPlan={statusPlan}
        vol={choiceDate.length}
        length = {saveMenuWeek.length}
        addRecipe={props.addRecipe}
        replaceRecipe={props.replaceRecipe}
        handleDeleteMenuDay={handleDeleteMenuDay}
        products={saveMenuWeek}
        handleDeleteRecipe={handleDeleteRecipe}
        changeMenuDay={handleChangeMenuDay}
        ingredients={ingredients}
        handleEdite = {handleEdite}
        handleAddMenuItem={handleAddMenuItem}  
        handleAutoReplace={handleAutoReplace}
        handleAddMeals={handleAddMeals}
        handleAutoReplaceMenu={handleAutoReplaceMenu}
        clickCreate={clickCreate} 
        blockedSaveMenu={blockedSaveMenu}
        blockedSaveMenus={props.blockedSaveMenu}
      /> 
      {saveMenuWeek.length > 0 &&
        <ProductList 
          date={choiceDate} 
          handlePrint={handlePrint}
          editFoodList={props.handleEditFoodList}
          servings={servings}  
          handleAddFoodList={props.handleAddFoodList}
          handleCheckProductList={props.handleCheckProductList} 
          menuPlane={saveMenuWeek.length > 0 && saveMenuWeek} 
          changeMenuDay={changeMenuDay} 
          blockedSaveMenu={props.blockedSaveMenu}
          handleChangeMenu={handleChangeMenu}
        />
      } 
      <AddRecipeInMenu 
        addRecipe={handleAddDish} 
        replaceRecipe={handleReplace} 
        replace={isOpen} 
        onClose={handleCloseMenuItem} 
        closeModal={handleCloseMenuItem} 
        positionMenuItem={positionMenuItem} 
        isOpen={isOpen}
      />
      <ModalContainer 
        isOpen={props.isOpen}
        onClose={props.onClose}
        title='settings'
      > 
        <Settings 
          type='plans'
        /> 
      </ModalContainer>
    </>
  );
}

const useSortableData = (items, config = null) => {
  const [sortConfig, setSortConfig] = React.useState(config);
  const sortedItems = React.useMemo(() => {
    let sortableItems = [...items];
    if (sortConfig !== null) {
      sortableItems.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'ascending' ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableItems;
  }, [items, sortConfig]);

  return { items: sortedItems, sortConfig };
};

const ProductTable = (props) => {
  const { items, sortConfig } = useSortableData(props.products);
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
  const [cardsPosition, setCardsPosition] = React.useState(1);
  const {recipes, sts} = useSelector(state => state.recipes)
  function checkWindowWidth() {
    setTimeout((items) => setWindowWidth(window.innerWidth), 500);
  };

  React.useEffect(()=> {
    window.addEventListener('resize', checkWindowWidth)
    if(window.innerWidth <= 768) {
        setCardsPosition(1)
      } else if(window.innerWidth >= 769) {
        setCardsPosition(1)
      }
      return () => window.removeEventListener('resize', checkWindowWidth);
    }, [windowWidth])
 
  const getClassNamesFor = (name) => {
    if (!sortConfig) {
      return;
    }
    return sortConfig.key === name ? sortConfig.direction : undefined;
  };

  return (
    <section className='table'> 
      <div className='menuweek__body'>
          <PlanSlides 
          date={props.date}
          recipes={recipes}
          sts = {sts}
          items={items}
          vol={props.vol}
          length = {props.length}
          statusPlan={props.statusPlan}
          handleDeleteRecipe={props.handleDeleteRecipe}
          cardsPosition={cardsPosition}
          handleDeleteMenuDay={props.handleDeleteMenuDay}
          handleAddMenuItem={props.handleAddMenuItem}
          addRecipe={props.addRecipe}
          replaceRecipe={props.replaceRecipe}
          changeMenuDay={props.changeMenuDay}
          ingredients={props.ingredients}
          handleEdite = {props.handleEdite} 
          handleAutoReplace={props.handleAutoReplace}
          handleAddMeals={props.handleAddMeals}
          handleAutoReplaceMenu={props.handleAutoReplaceMenu}
          clickCreate={props.clickCreate} 
          blockedSaveMenu={props.blockedSaveMenu}
          blockedSaveMenus={props.blockedSaveMenus}
        /> 
      </div>
   
    </section>
  );
};
